import {growthBookFeatureFlags} from '@/utils/constants/growthBookFeatureFlags'
import {useFeatureValue} from '@growthbook/growthbook-react'

const fallbackLanguages = [
  {
    language: 'English',
    code: 'en',
  },
  {
    language: 'Spanish (Mexico)',
    code: 'es_MX',
  },
]

export const useFeatureFlagLanguages = () => {
  const countryLanguages = useFeatureValue(growthBookFeatureFlags.languageList, {})
  const langauges = (countryLanguages['Mexico'] || fallbackLanguages).map(item => ({
    ...item,
    code: item.code.replace('-', '_'),
  }))

  return langauges || []
}
